/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-prototype-builtins */
import { useLocation } from 'react-router-dom'
import { iEtapa, iGroupByExtensions, iGroupData, iGroupDataList } from '../interfaces'
import { iIndicador, iPeriodo } from '../pages/Indicadores/gestao'
import { parseJwt } from '../services/token'

export function ObterCorEtapaPeloTipo(Tipo: number): string {
  let cor = ''
  switch (Tipo) {
    case 0:
      cor = '67C0A2'
      break

    case 1:
      cor = 'B265FF'
      break

    case 2:
      cor = '00B496'
      break

    case 3:
      cor = '7879F1'
      break

    case 4:
      cor = '6DA0FF'
      break

    case 5:
      cor = 'EC9C00'
      break

    case 6:
      cor = '00B45A'
      break

    case 7:
      cor = '365ad0'
      break

    case 8:
      cor = 'EB5757'
      break

    case 9:
      cor = 'E18787'
      break

    case 10:
      cor = '365ad0'
      break
    default:return 'C9C9C9'
  }
  return cor
}

export function ObterPercentual(qtdObservada: number, total: number): number {
  return qtdObservada * 100 / total
}

export function ObterCorFundoEtapaPeloTipo(Tipo: number): string {
  let cor = ''
  switch (Tipo) {
    case 0:
      cor = 'DBF0E9'
      break

    case 1:
      cor = 'F6EDFF'
      break

    case 2:
      cor = 'E6FEFA'
      break

    case 3:
      cor = 'F6EDFF'
      break

    case 4:
      cor = 'F0F5FE'
      break

    case 5:
      cor = 'F9F3DC'
      break

    case 6:
      cor = 'c9F3DC'
      break

    case 7:
      cor = 'adbcf7'
      break
    case 9:
      cor = 'E187874D'
      break
    case 10:
      cor = '1961E00D'
      break
    default: return 'white'
  }
  return cor
}

export function ObterToken(): string {
  const token = localStorage.getItem('token')
  return `bearer ${token as string}`
}

export function DistinctString(array: string[]): string[] {
  return array.filter((value, index, array) => array.indexOf(value) === index)
}

export function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search)
}

export function ValidarEtapa(Etapa: iEtapa): boolean {
  if (PropInvalida(Etapa)) {
    return false
  }

  if (PropInvalida(Etapa.dataInicio) && PropInvalida(Etapa.dataFim) && PropInvalida(Etapa.etapaPai) && PropInvalida(Etapa.tempoDuracao) && PropInvalida(Etapa.tempoInicio) && PropInvalida(Etapa.tempoAntesDesligamento) && PropInvalida(Etapa.tempoAposDesligamento)) {
    return false
  }

  if (PropInvalida(Etapa.dataInicio) && PropInvalida(Etapa.dataFim) && PropInvalida(Etapa.etapaPai) && (PropInvalida(Etapa.tempoDuracao) || (PropInvalida(Etapa.tempoInicio) && PropInvalida(Etapa.tempoAntesDesligamento) && PropInvalida(Etapa.tempoAposDesligamento)))) {
    return false
  }

  if (!PropInvalida(Etapa.etapaPai) && PropInvalida(Etapa.tempoDuracao)) {
    return false
  }

  if ((!PropInvalida(Etapa.dataInicio) && PropInvalida(Etapa.dataFim)) || (PropInvalida(Etapa.dataInicio) && !PropInvalida(Etapa.dataFim))) {
    return false
  }

  return true
}

export function ValidarSenha(senha: string): boolean {
  return /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.{6,})/.test(senha)
}

export function ValidarEmail(email: string): boolean {
  if (email === undefined || email === null || email.length > 120 || email.length < 5 || !email.includes('@')) {
    return false
  }

  return true
}

export function LimparCPF(cpf: string): string {
  return cpf.replace(/\D/g, '')
}

export function MascararCPF(valor: string): string {
  const digitos = LimparCPF(valor).slice(0, 11)
  let saida = digitos.slice(0, 3)
  if (digitos.length > 3) saida += `.${digitos.slice(3, 6)}`
  if (digitos.length > 6) saida += `.${digitos.slice(6, 9)}`
  if (digitos.length > 9) saida += `-${digitos.slice(9, 11)}`
  return saida
}

export function ValidaCPF(cpf: string): boolean {
  cpf = cpf.replace(/[\s.-]*/igm, '')
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false
  }
  let soma = 0
  let resto
  for (let i = 1; i <= 9; i++) { soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i) }
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(cpf.substring(9, 10))) return false
  soma = 0
  for (let i2 = 1; i2 <= 10; i2++) { soma = soma + parseInt(cpf.substring(i2 - 1, i2)) * (12 - i2) }
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(cpf.substring(10, 11))) return false

  return true
}

export function DeleteElementByPosition<T>(array: T[], index: number): T[] {
  array.splice(index, 1)
  return array
}

export function InsertElementByPosition<T>(arr: T[], index: number, newItem: T): T[] {
  return [...arr.slice(0, index), newItem, ...arr.slice(index)]
}

export function ArrayToChunks<T>(array: T[], size: number): T[][] {
  const chunks: T[][] = []
  for (let i = 0; i < array.length; i += size) {
    const chunk = array.slice(i, i + size)
    chunks.push(chunk)
  }
  return chunks
}

export function PropInvalida(...args: any[]): boolean {
  return args.some(arg => arg === '' || arg == null || arg === undefined || arg === 'NaN')
}

export function IsEq<T>(alvo: T, ...args: T[]): boolean {
  return args.some(arg => arg === alvo)
}

export const ObjetoVazio = (objectName: any): boolean => {
  return objectName && Object.keys(objectName).length === 0
}

export function converterData(val: string, plusDay?: number): Date {
  let year, month, day

  if (val.includes('/')) {
    [day, month, year] = val.split('/')
  } else if (val.includes('-')) {
    [year, month, day] = val.split('-')
  } else {
    throw new Error('Formato de data inválido')
  }

  if (plusDay) {
    const date = new Date(+year, +month - 1, +day + plusDay)
    return date
  } else {
    const date = new Date(+year, +month - 1, +day)
    return date
  }
}

export function converterDataEmString(val: string, plusDay: number): string {
  let year, month, day

  if (val.includes('/')) {
    [day, month, year] = val.split('/')
  } else if (val.includes('-')) {
    [year, month, day] = val.split('-')
  } else {
    throw new Error('Formato de data inválido')
  }

  if (day.includes('T')) {
    day = day.split('T')[0]
  }

  const date = new Date(+year, +month - 1, +day)
  date.setDate(date.getDate() + plusDay)

  const dayStr = String(date.getDate()).padStart(2, '0')
  const monthStr = String(date.getMonth() + 1).padStart(2, '0')
  const yearStr = String(date.getFullYear())

  return `${dayStr}/${monthStr}/${yearStr}`
}

export function ConverterDataHora(val: string, plusDay?: number): Date {
  const [day, month, yearComHora] = val.split('/')
  const year = yearComHora.split(' ')[0]
  const [Hours, Minutes] = yearComHora.split(' ')[1].split(':')

  if (plusDay) {
    return new Date(+year, +month - 1, +day + plusDay, +Hours, +Minutes)
  } else {
    return new Date(+year, +month - 1, +day, +Hours, +Minutes)
  }
}

export function UpdateElementByPosition<T>(arr: T[], index: number, upItem: T): T[] {
  const copy = [...arr]
  copy[index] = upItem
  return copy
}

export function transformarDuracao(tempo: number): string {
  const horas = (tempo / 60).toString().split('.')[0]
  const minutos = tempo % 60
  const str = `${horas} ${parseInt(horas) > 1 ? 'horas' : 'hora'} ${minutos > 0 ? `e ${minutos} minutos` : ''}`
  if (str.includes('0 hora')) {
    return str.replace('0 hora e', '')
  }
  return str
}

export function SubstringRoute(route: string, stop: string): string {
  return route.split(stop)[0]
}

export function AutorizarPI(): boolean {
  const jwt = parseJwt()
  const empresa = jwt.eid === 'acbf6a22-154e-480d-a465-61b990faa8bd' || jwt.eid === 'c5d7423c-5fbc-4917-a667-c2a2ec9693d7' || jwt.eid === 'ec62b8e5-b15e-4012-8046-49e2d5e407c6'
  const consultoria = jwt.consultoria === 'True'
  return empresa || jwt.uid === 'd87c1f61-9d40-4d38-ad30-ff4362a65360' || jwt.uid === '9cbbd54a-5cf0-4e74-9f4b-e5c7421d6d83' || jwt.uid === '01473c8b-58a0-4674-83a0-c9d2c8af719e' || jwt.uid === 'b6834d5c-a101-4551-a37f-696b10965a66' ||
  jwt.uid === '94dc7859-af8c-49c6-8673-549ccd05d54e' || consultoria || jwt.uid === '42fda8a8-b889-45dc-ba17-78a0a1a81897' || (jwt.eid === process.env.REACT_APP_AH_EMPRESA_ID && jwt.adm === 'True')
}

export function AutorizarAHPI(): boolean {
  const jwt = parseJwt()
  return jwt.uid === 'd87c1f61-9d40-4d38-ad30-ff4362a65360' || jwt.uid === '9cbbd54a-5cf0-4e74-9f4b-e5c7421d6d83' || jwt.uid === '01473c8b-58a0-4674-83a0-c9d2c8af719e' || jwt.uid === 'b6834d5c-a101-4551-a37f-696b10965a66' ||
  jwt.uid === '94dc7859-af8c-49c6-8673-549ccd05d54e' || jwt.uid === '42fda8a8-b889-45dc-ba17-78a0a1a81897' || (jwt.eid === process.env.REACT_APP_AH_EMPRESA_ID && jwt.adm === 'True') || jwt.uid === '671f143c-7d9c-46f4-9508-714cf7c14e55'
}

export function AutorizarConsultorPrismah(): boolean {
  const jwt = parseJwt()
  // login do comercial na conta de demonstracao, enxerga o PrismaH como consultor
  return jwt.uid === '9b91695a-2673-4010-9a04-b4a6803f3317'
}

export function AutorizarRelatorioClientes(): boolean {
  const jwt = parseJwt()
  return jwt.uid === '01473c8b-58a0-4674-83a0-c9d2c8af719e' || jwt.uid === '9cbbd54a-5cf0-4e74-9f4b-e5c7421d6d83' || (jwt.adm === 'True' && (jwt.eid === process.env.REACT_APP_AH_EMPRESA_ID || jwt.eid === 'c03874b6-f0af-4c4b-a349-3b48066baae6'))
}

export function AutorizarReprocessarPrismah(): boolean {
  const jwt = parseJwt()
  return jwt.uid === '01473c8b-58a0-4674-83a0-c9d2c8af719e' || jwt.uid === '9cbbd54a-5cf0-4e74-9f4b-e5c7421d6d83' || (jwt.adm === 'True' && (jwt.eid === process.env.REACT_APP_AH_EMPRESA_ID || jwt.eid === process.env.REACT_APP_ICECLOUD_EMPRESA_ID))
}

export function AutorizarGerirProprioPDI(): boolean {
  // conta da Alemanha Veiculos, o colaborador avalia e aprova o proprio PDI como se fosse o gestor
  return parseJwt().eid === '113ab578-0be5-493c-ad46-a0721f698409'
}

export function OcultarCargoParaNaoAdm(): boolean {
  // Tellescom não quer o cargo visível para ninguém além do administrador
  const jwt = parseJwt()
  return jwt.eid === '8a3d55a4-2267-443d-877d-34c245577789' && jwt.adm !== 'True'
}

export function EhTellescom(): boolean {
  return parseJwt().eid === '8a3d55a4-2267-443d-877d-34c245577789'
}

export function FluxoEtapa(rota: string): boolean {
  rota = rota.toLowerCase()
  return rota.includes('processo') || rota.includes('trilha')
}

export function BaseRotaReuniaoOne(pathname: string): string {
  return pathname.includes('NovaReuniaoOne') ? SubstringRoute(pathname, 'Visualizar') : '/Desempenho/NovaReuniaoOne/'
}

export function DestinoPosAprovacaoFeedback(pathname: string, reuniaoId?: string, participanteId?: string): string | undefined {
  const isTrilha = FluxoEtapa(pathname)
  if (!isTrilha && pathname.includes('NovaReuniaoOne')) return `${SubstringRoute(pathname, 'Feedback')}Visualizar/${reuniaoId ?? ''}`
  if (isTrilha && pathname.includes('Trilha')) return SubstringRoute(pathname, 'NovaReuniaoOne')
  if (isTrilha && pathname.includes('Processo')) return `/Rh/VisualizarPerfil/${participanteId ?? ''}`
  return undefined
}

export function IsLink(text: string): boolean {
  return text.includes('https') || text.includes('www') || text.includes('.com')
}

export function ExtrairLink(texto?: string): string | undefined {
  if (texto === undefined || texto === null || texto === '') return undefined
  const comEsquema = texto.match(/https?:\/\/[^\s"']+/i)
  if (comEsquema !== null) return comEsquema[0]
  // links colados sem esquema, tipo meet.google.com/abc ou www.empresa.com
  const semEsquema = texto.match(/(?:[\w-]+\.)+[a-z]{2,}(?:\/[^\s"']+)?/i)
  if (semEsquema !== null && (semEsquema[0].includes('/') || semEsquema[0].toLowerCase().startsWith('www.'))) {
    return `https://${semEsquema[0]}`
  }
  return undefined
}

export function GroupBy<T>(data: T[], getKey: (item: T) => string|number): iGroupByExtensions<T> {
  const extension: iGroupByExtensions<T> = {
    default: function() {
      return data.reduce((acc: iGroupData<T>, obj) => {
        const key = getKey(obj)

        // Se a chave não existir no acumulador, crie-a como um array vazio
        if (!acc[key]) {
          acc[key] = []
        }

        // Adicione o objeto ao grupo apropriado
        acc[key].push(obj)

        return acc
      }, {})
    },
    toList: function() {
      const arr = data.reduce((acc: iGroupData<T>, obj) => {
        const key = getKey(obj)
        // Se a chave não existir no acumulador, crie-a como um array vazio
        if (!acc[key]) {
          acc[key] = []
        }
        // Adicione o objeto ao grupo apropriado
        acc[key].push(obj)

        return acc
      }, {})

      const arr2: Array<iGroupDataList<T>> = []
      for (const key in arr) {
        if (arr.hasOwnProperty(key)) {
          const group = arr[key]
          arr2.push({
            key: key,
            data: group
          })
        }
      }
      return arr2
    }
  }

  return extension
}

export function HSelect<T, U>(data: T[], getKey: (item: T) => U, distinct: boolean): U[] {
  if (distinct) {
    const result: U[] = []
    for (const item of data) {
      const key = getKey(item)
      if (!result.some(e => JSON.stringify(e) === JSON.stringify(key)) && !PropInvalida(key)) {
        result.push(key)
      }
    }
    return result
  } else {
    return data.map(getKey)
  }
}

export function ReturnUniqueByKey(data: any[], key: string, orderBy?: string): any[] {
  let result: any[] = []
  for (const item of data) {
    if (!result.some(e => e[key] === item[key]) && item[key] !== null) {
      result.push(item)
    }
  }
  if (orderBy) {
    result = result.sort((a, b) => {
      if (a[orderBy] < b[orderBy]) {
        return -1
      }
      if (a[orderBy] > b[orderBy]) {
        return 1
      }
      return 0
    })
  }
  return result
}

export function HSelectMany<T, U>(array: T[], selector: (item: T) => U[]): U[] {
  return ([] as U[]).concat(...array.map(selector))
}

export const DownloadImage = (base64: string, filename?: string, extension?: string): any => {
  const base64Image = base64

  const binaryData = atob(base64Image.split(',')[1])
  const byteArray = new Uint8Array(binaryData.length)

  for (let i = 0; i < binaryData.length; i++) {
    byteArray[i] = binaryData.charCodeAt(i)
  }

  const blob = new Blob([byteArray], { type: 'image/png' })
  const blobUrl = URL.createObjectURL(blob)

  const downloadLink = document.createElement('a')
  downloadLink.href = blobUrl
  downloadLink.download = `${filename ?? 'imagem'}.${extension ?? 'png'}`
  downloadLink.style.display = 'none'

  document.body.appendChild(downloadLink)
  downloadLink.click()

  document.body.removeChild(downloadLink)
  URL.revokeObjectURL(blobUrl)
}

export function AdicionarDia(dataString: string, dias: number, minutos?: number): string {
  const dataAtual = new Date(dataString)
  dataAtual.setDate(dataAtual.getDate() + dias)
  const ano = dataAtual.getFullYear()
  const mes = String(dataAtual.getMonth() + 1).padStart(2, '0')
  const dia = String(dataAtual.getDate()).padStart(2, '0')
  const hora = String(dataAtual.getHours()).padStart(2, '0')
  const minuto = String(dataAtual.getMinutes() + (minutos ?? 1)).padStart(2, '0')

  const novaDataString = `${ano}-${mes}-${dia}T${hora}:${minuto}`
  return novaDataString
}

export function FormatarCompetencia(competencia: string): string {
  let palavras = competencia.toLocaleLowerCase().split(' ')
  if (palavras.length === 1) {
    palavras = competencia.replace('/', ' / ').split(' ')
  }
  for (let i = 0; i < palavras.length; i++) {
    if (palavras[i][0] !== undefined) {
      palavras[i] = palavras[i][0].toUpperCase() + palavras[i].substr(1)
    }
  }
  return palavras.join(' ')
}

export function sleep(ms: number): void {
  const startTime = new Date().getTime()
  while (new Date().getTime() - startTime < ms) { /* empty */ }
}

export async function sleepAsync(ms: number): Promise<void> {
  return await new Promise(resolve => setTimeout(resolve, ms))
}

export function formatarData(data: string): string {
  const dataStr = data.split('T')[0]
  const dataArr = dataStr.split('-')
  return `${dataArr[2]}/${dataArr[1]}/${dataArr[0]}`
}

// Converte a data recebida da API (UTC) para o fuso do usuário
export function formatarDataHora(data: string): string {
  if (!data) {
    return ''
  }

  if (!data.includes('T')) {
    return formatarData(data)
  }

  const date = new Date(data)
  if (isNaN(date.getTime())) {
    return ''
  }

  const dia = String(date.getDate()).padStart(2, '0')
  const mes = String(date.getMonth() + 1).padStart(2, '0')
  const ano = date.getFullYear()
  const hora = String(date.getHours()).padStart(2, '0')
  const minuto = String(date.getMinutes()).padStart(2, '0')

  return `${dia}/${mes}/${ano} às ${hora}:${minuto}`
}

// Tempo passado desde a data informada: min ate 1h, horas ate 24h, dias acima disso
export function tempoDecorrido(data: string): string {
  if (!data) {
    return ''
  }

  const date = new Date(data)
  if (isNaN(date.getTime())) {
    return ''
  }

  const minutos = Math.floor((Date.now() - date.getTime()) / 60000)
  if (minutos < 1) {
    return 'agora'
  }

  if (minutos < 60) {
    return `${minutos} min`
  }

  const horas = Math.floor(minutos / 60)
  if (horas < 24) {
    return `${horas} h`
  }

  const dias = Math.floor(horas / 24)
  return `${dias} ${dias === 1 ? 'dia' : 'dias'}`
}

export function returnDate(dataString: string): Date {
  const partes = dataString.split('/')
  const dataFormatada = partes[2] + '-' + partes[1] + '-' + partes[0]
  return new Date(dataFormatada)
}

export function obterDataParaCsv(): string {
  const data = new Date()
  const dia = String(data.getDate()).padStart(2, '0')
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const ano = data.getFullYear()
  const horas = String(data.getHours()).padStart(2, '0')
  const minutos = String(data.getMinutes()).padStart(2, '0')

  return `${dia}-${mes}-${ano}-${horas}-${minutos}`
}

export function FormatarMensagemEditorDeTexto(texto: string): string {
  return texto.split('<p>').join('<p style="line-height: 200%">').split('<p style="line-height: 200%"></p>').join('<br>').split('<h1>').join('<h1 style="line-height: 200%">').split('<h1>').join('<h1 style="line-height: 200%">').split('<h2>').join('<h2 style="line-height: 200%">').split('<h3>').join('<h3 style="line-height: 230%">').split('<h4>').join('<h4 style="line-height: 250%">').split('<h5>').join('<h5 style="line-height: 300%">').split('<h6>').join('<h6 style="line-height: 300%">').split('<ul>').join('<ul style="padding-left: 16px">').split('<ol>').join('<ol style="padding-left: 16px">')
}

export function FormatarMensagemCartaConvite(texto: string): string {
  return texto.split('<p ').join('<p style="line-height: 170%; font-size: 30px;" ')
    .split('<a ').join('<a style="line-height: 170%; font-size: 30px;" ')
    .split('<p style="line-height: 200%"></p>').join('<br>')
}

export function GetDataFromMonthDate(data?: string): string | undefined {
  if (!data) return
  const [year, month] = data.split('-')

  return new Date(parseInt(year), parseInt(month) - 1, 1).toISOString()
}

export const processString = (input: string): string[] => {
  const sanitizedInput = input.replace(/^P\.\d+ - /, '')
  const words = sanitizedInput.split(' ')
  const result: string[] = []

  for (let i = 0; i < words.length; i++) {
    const word = words[i]
    if (word.length <= 3 && i > 0) {
      result[result.length - 1] += ` ${word}`
    } else {
      result.push(word)
    }
  }

  return result
}

export const splitByClosest = (input: string, qtd?: number): string[] => {
  const words = input.split(' ')
  const result: string[] = []
  let currentChunk = ''

  const invisibleChars = ['\u200B', '\u200C', '\u200D', '\u00A0', '\u2060']

  const getRandomInvisibleChar = () => {
    const index = Math.floor(Math.random() * invisibleChars.length)
    return invisibleChars[index]
  }

  const splitLongWord = (word: string, limit: number): string[] => {
    const halfIndex = Math.ceil(word.length / 2)
    return [`${word.substring(0, halfIndex)}-`, word.substring(halfIndex)]
  }

  for (let i = 0; i < words.length; i++) {
    let nextWord = words[i]

    while (nextWord.length > (qtd ?? 13)) {
      const [part1, part2] = splitLongWord(nextWord, qtd ?? 10)
      if (currentChunk.length > 0) {
        result.push(currentChunk + getRandomInvisibleChar())
        currentChunk = ''
      }
      result.push(part1 + getRandomInvisibleChar())
      nextWord = part2
    }

    const potentialLength = currentChunk.length + nextWord.length + (currentChunk.length > 0 ? 1 : 0)

    if (potentialLength <= (qtd ?? 10)) {
      currentChunk += (currentChunk.length > 0 ? ' ' : '') + nextWord
    } else {
      result.push(currentChunk + getRandomInvisibleChar())
      currentChunk = nextWord
    }
  }

  if (currentChunk) {
    result.push(currentChunk + getRandomInvisibleChar())
  }

  return result
}

export function GetValorPrevistoAteEsseMes(e: iIndicador, ValorPrevisto: number): string {
  return ValorPrevisto === 0 ? 'N/A' : (e.tipoMeta === 0 ? `${e.medidaMeta ?? ''}${FormatarNumero(ValorPrevisto, e)}` : `${FormatarNumero(ValorPrevisto, e)}${e.medidaMeta ?? ''}`)
}

export function GetValorAcumuladoAteEsseMes(e: iIndicador, ValorAcumulado: number): string {
  return ValorAcumulado === 0 ? 'N/A' : (e.tipoMeta === 0 ? `${e.medidaMeta ?? ''}${FormatarNumero(ValorAcumulado, e)}` : `${FormatarNumero(ValorAcumulado, e)}${e.medidaMeta ?? ''}`)
}

export function GetValueCircularProgressIndicador(e: iIndicador, ValorPrevisto: number, ValorAcumulado: number): number {
  return ValorPrevisto === 0 ? 0 : (e.metaInversa ? (ValorPrevisto / ValorAcumulado) : (ValorAcumulado / ValorPrevisto)) * 100
}

/**
 * `pct` já vem normalizado por polaridade (ver GetValueCircularProgressIndicador
 * e GetValorAcumulado, que invertem a razão quando metaInversa): maior = melhor,
 * tanto para meta normal quanto para meta inversa. Não reaplique `metaInversa` aqui.
 * Use `indisponivel` quando o indicador exibe 'N/A' (sem previsto ou sem acumulado).
 */
export function ObterCorPercentual(pct: number, indisponivel?: boolean): string {
  if (indisponivel === true) {
    return 'var(--c5)'
  } else if (!Number.isFinite(pct)) {
    return 'var(--Green2)'
  } else if (pct <= 90) {
    return 'var(--Red)'
  } else if (pct <= 95) {
    return 'var(--Orange)'
  } else {
    return 'var(--Green2)'
  }
}

export function GetValorPrevisto(periodos: iPeriodo[], mesPersonalizado?: number): number {
  let mesAtual = mesPersonalizado ?? new Date().getUTCMonth() + 1
  let anoAtual = new Date().getUTCFullYear()
  let periodo = periodos.find(e => e.ano === anoAtual)
  while (!periodo) {
    if (anoAtual < 2000) {
      break
    }
    anoAtual--
    periodo = periodos.find(e => e.ano === anoAtual)
  }

  if (periodo?.meses && periodo?.meses.length > 0 && periodo?.ano && periodo?.ano < new Date().getUTCFullYear()) {
    mesAtual = periodo.meses.sort((a, b) => b.numeroMes - a.numeroMes)[0].numeroMes
  }

  let mes = periodo?.meses.find(e => e.numeroMes === mesAtual)
  while (mes === null || mes?.previsto === 0 || mes?.previsto === null) {
    if (mesAtual < 0) {
      break
    }
    mesAtual--
    mes = periodo?.meses.find(e => e.numeroMes === mesAtual)
  }

  return mes?.previsto ?? 0
}

export function GetValorAcumulado(periodos: iPeriodo[], tipoMeta: number, meta?: number, metaInversa?: boolean): number {
  let response = 0
  if (tipoMeta === 5 && periodos.length > 0) {
    const meses = periodos?.sort((a, b) => b.ano - a.ano)[0]?.meses?.filter(e => e.real)?.sort((a, b) => b.numeroMes - a.numeroMes)
    if (meses.length > 0) {
      response = meses[0].real ?? 0
    }
  } else {
    periodos.forEach(e => e.meses.forEach(m => {
      if (m.real) {
        response += m.real
      }
    }))
  }

  if (meta) {
    return (metaInversa ? response === 0 ? 0 : (meta / response) : (response / meta)) * 100
  } else {
    return response
  }
}

export function GetMetaFinal(e: iIndicador): string {
  return e.tipoMeta === 0 ? `${e.medidaMeta ?? ''}${FormatarNumero(e.meta, e)}` : `${FormatarNumero(e.meta, e)}${e.medidaMeta ?? ''}`
}

export function FormatarNumero(num: number, indicador: iIndicador): string {
  let response = ''
  const toFixed = indicador.tipoMeta === 5 || indicador.tipoMeta === 0

  const numero = toFixed ? num.toFixed(2) : num.toString()

  const values = numero.split('.')

  for (let i = 0; i < (values[0].length / 3); i++) {
    for (let index = 1; index < 4; index++) {
      if (values[0][values[0].length - index - (i * 3)]) {
        response = values[0][values[0].length - index - (i * 3)] + response
      }
    }
    if ((i + 1) < (values[0].length / 3)) {
      response = '.' + response
    }
  }

  if (toFixed) {
    response += `,${values[1]}`
  }
  return response
}

export function formatarDataAno(dataString: string): string {
  const meses = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ]

  const [ano, mes] = dataString.split('-')

  const nomeMes = meses[parseInt(mes) - 1]

  return `${nomeMes} de ${ano}`
}

export function GetNomeItemFeedback(tipo: number): string {
  switch (tipo) {
    case 0:
      return 'Pesquisa de Competências'
    case 1:
      return 'PDI Anterior'
    case 2:
      return 'Feedback anterior'
    case 3:
      return 'Pesquisa de Competências (quantitativa)'
    case 4:
      return 'Pesquisa de Competências (indicativa)'
    case 5:
      return 'Formulários personalizados'
    case 6:
      return 'Pesquisas de desempenho'
    case 7:
      return 'Nine box'
    case 8:
      return 'Reunião 1:1'
    case 9:
      return 'Onboarding'
    case 10:
      return 'Pesquisas internas'
    case 11:
      return 'Reunião 1:1'
    case 12:
      return 'Calibração Nine Box'
    case 13:
      return 'Calibração de pesquisa'
    case 14:
      return 'PDI'
    case 15:
      return 'Percepções sobre a empresa'
    default:
      return ''
  }
}

export function GetDescricaoItemFeedback(tipo: number): string {
  switch (tipo) {
    case 0:
      return 'Incluir novas pesquisas quantitativas ou indicativas'
    case 1:
      return 'Plano de Desenvolvimento Individual já existente'
    case 2:
      return 'O feedback passado do colaborador'
    case 3:
      return 'Realizará uma avaliação quantitativa'
    case 4:
      return 'Realizará uma avaliação indicativa'
    case 5:
      return 'Formulários novos ou existentes'
    case 6:
      return 'Histórico de pesquisas de percepção/desempenho'
    case 7:
      return 'Última calibração do Nine box'
    case 8:
      return 'Registros de reuniões individuais'
    case 9:
      return 'Informações do processo de integração do colaborador'
    case 10:
      return 'Histórico de pesquisas internas'
    case 11:
      return 'Reunião de condução do feedback'
    case 12:
      return 'A partir do feedback'
    case 13:
      return 'Discutir e consolidar as respostas de uma pesquisa 90°'
    case 14:
      return 'Plano de ação através dos itens selecionados no feedback​'
    case 15:
      return 'Identifique pontos positivos e de atenção da empresa'
    default:
      return ''
  }
}

export function GetNextOrder(array: Array<{ ordem: number }>): number {
  if (array.length === 0) {
    return 1
  }

  const maxOrder = Math.max(...array.map(item => item.ordem))
  return maxOrder + 1
}

export function CheckIsItemDeVisualizacao(tipoItem: number): boolean {
  return [1, 7, 2, 10, 8, 9, 6].includes(tipoItem)
}

export function CheckIsItemPadrao(tipoItem: number): boolean {
  return [6, 7, 10].includes(tipoItem)
}

export const formatNumberBR = (
  value: number | string | null | undefined,
  fallback = '0,00'
): string => {
  if (value === null || value === undefined) return fallback

  const nf = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  if (typeof value === 'number') {
    if (!isFinite(value)) return fallback
    return nf.format(value)
  }

  const raw = String(value).trim()
  if (!raw) return fallback

  let num = NaN
  if (raw.includes(',')) {
    const cleaned = raw.replace(/\./g, '').replace(',', '.')
    num = Number(cleaned)
  } else {
    const cleaned = raw.replace(/[^0-9.-]/g, '')
    num = Number(cleaned)
  }

  if (Number.isNaN(num)) return fallback
  return nf.format(num)
}
